import { useMemo } from 'react';

interface YearSwitcherProps {
  value: number | 'all';
  options: number[];
  onChange: (value: number | 'all') => void;
}

export function YearSwitcher({ value, options, onChange }: YearSwitcherProps) {
  const items = useMemo<Array<{ key: string; label: string; value: number | 'all' }>>(() => {
    return [
      { key: 'all', label: '全部', value: 'all' as const },
      ...options.map((y) => ({ key: String(y), label: String(y), value: y })),
    ];
  }, [options]);

  return (
    <div className="inline-flex flex-wrap items-center gap-1 rounded-lg bg-white/5 p-1 ring-1 ring-white/10">
      {items.map((item) => {
        const active = item.value === value;
        return (
          <button
            key={item.key}
            type="button"
            onClick={() => onChange(item.value)}
            className={
              active
                ? 'px-3 py-1 text-xs font-medium rounded-md bg-gradient-to-r from-cyan-500/30 to-violet-500/30 text-cyan-100 ring-1 ring-cyan-400/30 shadow-[0_0_12px_rgba(56,189,248,0.4)]'
                : 'px-3 py-1 text-xs font-medium rounded-md text-slate-400 hover:text-slate-200 hover:bg-white/5 transition-colors'
            }
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
